import React, { type FC, useState } from "react";
import { WelcomePopup } from "@components/User/WelcomePopup";
import { useGetCurrentSessionIfMeta } from "clientState/useGetCurrentSessionIfMeta/useGetCurrentSessionIfMeta";

import UserVerificationModal from "../UserVerificationModal";
import { TEN_MINUTES_IN_MS } from "./constants";
import type { UserVerificationManagerProps } from "./contract";

const isAtLeastXMillisecondsAgo = (
  creationTimestamp: number | string,
  milliseconds: number,
): boolean => {
  return Date.now() - new Date(creationTimestamp).getTime() >= milliseconds;
};

const UserVerificationManager: FC<UserVerificationManagerProps> = ({
  isMeta,
}) => {
  const [showWelcomePopup, setShowWelcomePopup] = useState(!isMeta);
  const { loading, currentSession, errors } =
    useGetCurrentSessionIfMeta(isMeta);
  const currentSessionIfMeta = !loading && !errors?.length && currentSession;
  const isSessionOlderThanTenMinutes =
    currentSessionIfMeta &&
    isAtLeastXMillisecondsAgo(
      currentSessionIfMeta.creationTimestamp,
      TEN_MINUTES_IN_MS,
    );
  const shouldShowUserVerificationModal =
    !showWelcomePopup && isSessionOlderThanTenMinutes;
  const shouldShowWelcomePopup =
    showWelcomePopup || (!isSessionOlderThanTenMinutes && !loading);

  const handleCloseModal = (): void => {
    setShowWelcomePopup(true);
  };

  return (
    <>
      {shouldShowUserVerificationModal && (
        <UserVerificationModal onClick={handleCloseModal} />
      )}

      {shouldShowWelcomePopup && <WelcomePopup />}
    </>
  );
};

export default UserVerificationManager;
